// extracted by mini-css-extract-plugin
module.exports = {"acc":"views-Settings__acc--lIGCl","header":"views-Settings__header--2luRQ"};